import apiClient from '@/api/apiClient'

export const getBlocklist = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}/block_requests`)

export const approveBlockRequest = (accountId, id) =>
  apiClient.post(`api/v1/accounts/${accountId}/block_requests/${id}/approve`)

export const rejectBlockRequest = (accountId, id) =>
  apiClient.post(`api/v1/accounts/${accountId}/block_requests/${id}/reject`)

export const unblockContact = (accountId, contactId) =>
  apiClient.post(`api/v1/accounts/${accountId}/block_requests/unblock`, {
    contact_id: contactId,
  })
